import React from 'react';
import Link from 'next/link';
import {Input} from '@damascus-components/Input_new';
import Button from '@components/Button';
import SVGIcons from '@components/SVGIcon';
import {LINKS, LITERALS as L, SOCIALS} from './BottomSection.constants';

import cn from './BottomSection.module.scss';
import {trackMouseClicks} from '@utils/googleAnalytics/googleAnalyticsEvents';
import MuiContainer from '@new-components/atoms/MuiContainer';

export function BottomSection() {
  const mailtoHref = `mailto:${L.EMAIL}`;

  return (
    <MuiContainer className={cn.widthControl}>
      <div className={cn.btm}>
        <div className={cn.btm_p1}>
          <div className={cn.btm_p1__newsletter}>
            <p>{L.SUBSCRIBE_TEXT}</p>
            <Input
              className={cn.input}
              endAdornment={
                <Button className={cn.submitButton}>
                  <SVGIcons type='rightarrow-svg' />
                </Button>
              }
            />
          </div>
          <div className={cn.btm_p1__follow}>
            <p>{L.FOLLOW_TEXT}</p>
            <ul>
              {SOCIALS.map(({iconType, href}) => (
                <li key={iconType}>
                  <Link
                    href={href}
                    target='_blank'
                    onClick={() =>
                      trackMouseClicks(
                        {
                          type: 'link',
                          label: 'footer_link',
                          target: href,
                        },
                        {name: iconType}
                      )
                    }
                    prefetch={false}>
                    <SVGIcons type={iconType} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className={cn.btm_p1__email}>
            <p>{L.EMAIL_TEXT}</p>
            <a href={mailtoHref}>{L.EMAIL}</a>
          </div>
          <div className={cn.btm_p1__phone}>
            <p>{L.PHONE_TEXT}</p>
            <a href={`tel:800-25327`}>{L.PHONE}</a>
          </div>
          <div className={cn.btm_p1__contact}>
            <Link
              href={L.CONTACT_HREF}
              target='_blank'
              onClick={() =>
                trackMouseClicks(
                  {
                    type: 'link',
                    label: 'footer_link',
                    target: L.CONTACT_HREF,
                  },
                  {name: L.CONTACT_BTN_TEXT}
                )
              }
              prefetch={false}>
              {L.CONTACT_BTN_TEXT}
            </Link>
          </div>
        </div>
        <div className={cn.btm_p2}>
          <div className={cn.btm_p2__links}>
            {LINKS.map(({href, label}) => (
              <Link
                href={href}
                key={label}
                target='_blank'
                onClick={() =>
                  trackMouseClicks(
                    {
                      type: 'link',
                      label: 'footer_link',
                      target: href,
                    },
                    {name: label}
                  )
                }
                prefetch={false}>
                {label}
              </Link>
            ))}
          </div>
          <div className={cn.btm_p2__copyright}>{L.COPYRIGHT_TEXT}</div>
          <div className={cn.btm_p2__captcha}>{L.CAPTCHA_TEXT}</div>
        </div>
      </div>
    </MuiContainer>
  );
}
